import './sendOtp.scss';
import React from 'react';
import { Translate, translate, Storage, getUrlParameter } from 'react-jhipster';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { IRootState } from 'app/shared/reducers';
import { otpUpdatePhone, storeInfoNewPhone } from './sendOtp.reducer';
import { KEY_LOGIN, SUCCESS } from 'app/config/constants';
import { Row, Col, Alert, Button, TabContent, TabPane, UncontrolledTooltip } from 'reactstrap';
import { generateCaptcha } from '../account/password-reset/password-reset.reducer';

export interface IUpdatePhoneProps extends StateProps, DispatchProps, RouteComponentProps<{}> {}

export interface IUpdatePhoneState {
  captcha: string;
}

// if eidt type update must edit both client and server
const TYPE_UPDATE_PHONE = 'UpdatePhone';
var dictInfo = {};

export class UpdatePhoneNumber extends React.Component<IUpdatePhoneProps, IUpdatePhoneState> {
  state: IUpdatePhoneState = {
    captcha: ''
  };
  componentWillMount() {
    this.props.generateCaptcha();
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.responseSendOtpUpdatePhone !== nextProps.responseSendOtpUpdatePhone) {
      const { responseSendOtpUpdatePhone } = nextProps;
      if (responseSendOtpUpdatePhone.status == SUCCESS) {
        dictInfo['id'] = responseSendOtpUpdatePhone.id;
        this.props.storeInfoNewPhone(dictInfo);
      } else {
        alert(responseSendOtpUpdatePhone.message);
      }
    }
    if (this.props.responseCap !== nextProps.responseCap) {
      const { responseCap } = nextProps;
      if (responseCap.status === SUCCESS) {
        this.setState({
          captcha: responseCap.message
        });
      }
    } else {
      this.props.generateCaptcha();
    }
  }
  handleValidSubmit = (event, values) => {
    dictInfo['phone'] = values.phone.trim();
    this.props.otpUpdatePhone(values.phone.trim(), dictInfo['keyLogin'], values.captcha);
  };
  getKeyLoginFromUrl = () => {
    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl).get(KEY_LOGIN);
    dictInfo['keyLogin'] = params;
  };
  invokeResetCaptcha = () => {
    this.props.generateCaptcha();
  };
  render() {
    const { responseSendOtpUpdatePhone } = this.props;
    if (responseSendOtpUpdatePhone && responseSendOtpUpdatePhone.status === 'SUCCESS') {
      return (
        <Redirect
          push
          to={{
            pathname: `/sendOtp`,
            state: {}
          }}
        />
      );
    }
    this.getKeyLoginFromUrl();
    return (
      <div className="box-register">
        <AvForm style={{ paddingTop: '8px' }} id="register-form" onValidSubmit={this.handleValidSubmit}>
          <label style={{ textAlign: 'center', display: 'block', fontWeight: 'bold', marginBottom: '30px' }}>
            Nhập số điện thoại nhận OTP mới
          </label>
          <AvField
            name="phone"
            placeholder={translate('global.form.mobile.placeholder')}
            label="Số điện thoại"
            validate={{
              required: { value: true, errorMessage: translate('global.messages.validate.mobile.required') },
              number: { value: true, errorMessage: translate('global.messages.validate.mobile.invalid') },
              minLength: { value: 10, errorMessage: translate('global.messages.validate.mobile.minlength') },
              maxLength: { value: 11, errorMessage: translate('global.messages.validate.mobile.maxlength') }
            }}
          />
          <label>{translate('global.form.code.label')}</label>
          <Row style={{ flex: 1 }}>
            <Col style={{ flex: 0.6 }}>
              <AvField
                name="captcha"
                label=""
                placeholder="Nhập mã xác thực"
                type="text"
                validate={{
                  required: { value: true, errorMessage: 'Nhập mã xác thực' }
                }}
              />
            </Col>

            <Col style={{ flex: 0.3 }}>
              <img style={{ height: '39px' }} src={`data:image/jpeg;base64,${this.state.captcha}`} alt="" />
            </Col>

            <Col style={{ flex: 0.1 }}>
              <img
                // style={{ marginTop: '40px' }}
                className=""
                src={require('app/images/header/refresh.svg')}
                onClick={this.invokeResetCaptcha}
                alt=""
              />
            </Col>
          </Row>
          <Button style={{ marginTop: '50px' }} className="btn-register" type="submit" block>
            <Translate contentKey="register.form.button">Register</Translate>
          </Button>
        </AvForm>
      </div>
    );
  }
}
const mapStateToProps = ({ sendotp, passwordReset }: IRootState) => ({
  responseSendOtpUpdatePhone: sendotp.responseSendOtpUpdatePhone,
  responseCap: passwordReset.responseCaptcha
});
const mapDispatchToProps = { otpUpdatePhone, storeInfoNewPhone, generateCaptcha };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdatePhoneNumber);
